import { DomListener } from "../../core/DomListener.js";
export default class AgreementBox extends DomListener {
  constructor($root, options) {
    super($root);
    this.$root = $root;
    this.options = options;
    this.idModalOverlay = `agreement_${options.formId}_${options.formIndex}`;
    this.idModalWrap = `agreement_wrap_${options.formId}_${options.formIndex}`;
    this.idModalLabelAgree = `agreement_label_${options.formId}_${options.formIndex}`;
    this.idModalTextAgree = `agreement_text_${options.formId}_${options.formIndex}`;
    this.idModalCloseButton = `agreement_close_${options.formId}_${options.formIndex}`;
    this.idModalCloseButtonWrap = `agreement_close_wrap_${options.formId}_${options.formIndex}`;
  }
  async init() {
    await this.loadTransporter();
    this.$agreementModal = document.body.querySelector(`#${this.idModalOverlay}`);
    this.$agreementText = this.$agreementModal.querySelector(`#${this.idModalTextAgree}`);
    this.$modalCloseButton = this.$agreementModal.querySelector(`#${this.idModalCloseButton}`);
    this.$agreementBox = document.body.querySelector(`#${this.idModalWrap}`);
    this.$agreementText.addEventListener("wheel", this.stopPropagateWheelEvent, {
      passive: false
    });
    this.listeners = [{
      eventName: "click",
      method: "onClickOverlay",
      el: document.body
    }, {
      eventName: "click",
      method: "hideAgreementBox",
      el: this.$modalCloseButton
    }];
    this.initDomListener();
    this.setGoogleFont();
  }
  toHTML() {
    return `
            <div class="qform-agreement__overlay ${this.options.styles.formStyleCommon?.theme ? "qform-theme-black" : "qform-theme-default"}" id="${this.idModalOverlay}">
                <div class="qform-agreement__modal" id="${this.idModalWrap}">
                <div class="qform-agreement__label" id="${this.idModalLabelAgree}"></div>
                <div class="qform-agreement__text" id="${this.idModalTextAgree}">
                  <i class="qform-agreement__text-loader"></i>
                </div>
                <div class="qform-agreement__close-btn-wrapper" id="${this.idModalCloseButtonWrap}">
                    <button type="button" class="qform-agreement__close-btn" id="${this.idModalCloseButton}">${this.options.messages.buttonClose}</button>
                </div>
                </div>
            </div>
        `;
  }
  async loadTransporter() {
    const transporterModule = await import(/* webpackChunkName: "transporter" */
    "../../core/transporter.js");
    this.Transporter = transporterModule.transporter;
  }
  getTextAgreement(path) {
    this.Transporter.post(`https://${this.options.server_host}${path}`, {
      body: {
        formId: this.options.formId,
        domain: this.options.domain
      },
      options: {
        method: "POST",
        decode: false
      },
      callback: this.setTextAgreement = this.setTextAgreement.bind(this)
    });
  }
  setTextAgreement(data) {
    this.$agreementText.innerHTML = `${data.agreement?.text || ""} <br> ${data.agreement?.extraText || ""}`;
  }
  setGoogleFont() {
    if (this.options.useDesign) {
      this.$agreementModal.style.fontFamily = this.options.styles.formStyleText.font ? `"${this.options.styles.formStyleText.font.name}", sans-serif` : "inherit";
    }
  }
  onClickOverlay(event) {
    if (!this.$agreementModal.querySelector(".qform-agreement__modal").contains(event.target)) this.hideAgreementBox(event);
  }
  showAgreementBox() {
    //подстройка моального окна под вьюпорт
    if (this.options.device === "mobile") {
      this.$agreementText.style.height = `calc(${window.visualViewport.height}px - 180px)`;
    }
    this.$agreementModal.classList.add("qform-agreement-open");
    document.body.addEventListener("wheel", this.preventWheelEvent, {
      passive: false
    });
  }
  hideAgreementBox() {
    this.$agreementModal.classList.contains("qform-agreement-open") ? this.$agreementModal.classList.remove("qform-agreement-open") : null;
    document.body.removeEventListener("wheel", this.preventWheelEvent, {
      passive: false
    });
  }
  preventWheelEvent(event) {
    event.preventDefault();
  }
  stopPropagateWheelEvent(event) {
    event.stopPropagation();
  }
}